import { Logo, Menu, ButtonIcon, Icon } from "@saviynt/design-system";
import React from "react";
import { GetAuth } from "../../../contexts/AuthProvider";
import "./SavContainer.css";

/**
 * Container component with Saviynt branding
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @returns {JSX.Element} SavContainer component
 */
function SavContainer({ children }) {
  const auth = GetAuth();

  const handleLogout = async () => {
    // End session on backend (removes from active sessions, allows re-login)
    // Does NOT reseal vault — other users' sessions continue
    try {
      if (auth.user) {
        await fetch("/api/v1/bg/session-end", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: auth.user }),
        });
      }
    } catch (e) {
      // best-effort
    }
    auth.logOut();
    window.location.reload();
  };

  const menuOptions = [
    { label: "Logout", value: "logout" },
  ];

  const handleMenuChange = (selectedOption) => {
    if (selectedOption.value === "logout") {
      handleLogout();
    }
  };

  return (
    <div className="SavContainer">
      <div className="SavContainer-header">
        <div className="SavContainer-logo">
          <Logo kind="SaviyntWhite" />
        </div>
        {auth.token && (
          <div className="SavContainer-menu">
            <Menu
              options={menuOptions}
              onChange={handleMenuChange}
              trigger={
                <ButtonIcon
                  size="medium"
                  kind="outlinedNeutral"
                  icon={<Icon kind="MenuHamburger" />}
                  ariaLabel="Menu"
                />
              }
            />
          </div>
        )}
      </div>
      <div className="SavContainer-content">{children}</div>
    </div>
  );
}

export default SavContainer;
